import { controlActions as routing } from './routing/actions';

export const controlActions = {
  routing,
};
